class Tables {
  constructor() {
    this.init();
  }

  init() {
    this.$tables = $( '.article__content table' );

    this._wrapTables();
    this._setUpResponsiveTables();
  }

  _wrapTables() {
    this.$tables.wrap( '<div class="table__container"></div>' );
  }

  _setUpResponsiveTables() {
    this.$tables.each((i, tableEl) => {
      const tableArr    = [];
      const headerCells = tableEl.querySelectorAll( 'thead th, thead td' );
      const bodyRows    = tableEl.querySelectorAll( 'tbody tr' );

      if (headerCells.length) {
        this._getHeaderContent(tableArr, headerCells);
        this._setTableDataAtts(bodyRows, tableArr);
      }
    });
  }

  _getHeaderContent(tableArr, headerCells) {
    for ( let i = 0; i < headerCells.length; i++ ) {
      tableArr.push(headerCells[i].innerHTML);
    }
  }

  _setTableDataAtts(bodyRows, tableArr) {
    let children;

    for ( let i = 0; i < bodyRows.length; i++)  {
      children = bodyRows[i].children;

      for ( let j = 0; j < children.length; j++ ) {
        children[j].setAttribute('data-th', tableArr[j]);
        children[j].classList.add('has-header');
        $( children[j] ).wrapInner( '<span class="cell-contents"></span>' );
      }
    }
  }
}

export default Tables;
